import React from "react";
import { Grid } from "@mui/material";
import { usePermissions } from "../pages/login/PermissionContext";
export default function LayoutWithbg({ children }) {
  const { userInfo } = usePermissions();
  const accessToken = sessionStorage.getItem("accessToken");
  return (
    <div
      style={{
        // minHeight: "100vh",
        backgroundImage: "url('/newImages/login_background.svg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: "column",
        flex: 1,
      }}
    >
      {/* Header Section */}
      <Grid
        container
        alignItems="center"
        sx={{
          padding: "30px 20px",
          fontFamily: "Arial, sans-serif",
        }}
      >
        {/* Empty space taking 8 columns */}
        <Grid item xs={0} sm={8}></Grid>
        {/* Facility Name - only show if access token is present */}
        {/* {accessToken && (
          <Grid item xs={2}>
            <div
              style={{ fontSize: "14px", fontWeight: "bold", color: "#000" }}
            >
              Facility Name :{" "}
              <span style={{ fontWeight: "normal" }}>
                {userInfo?.facility_name || "-"}
              </span>
            </div>
          </Grid>
        )} */}
          <Grid item xs={0} sm={2}></Grid>
        {/* ORG Code moved to the profile dropdown in the top-right */}
      </Grid>
      {/* Page Content */}
      {/* <div style={{ flex: 1 }}>{children}</div> */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: "0 0 40px 0",
        }}
      >
        <div
          style={{
            width: "100vw",
            margin: "0",
            padding: "0",
            backgroundColor: "#FDFDFD",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
